import { render, staticRenderFns } from "./AiSummary.vue?vue&type=template&id=b6ba9bb8&scoped=true&"
import script from "./AiSummary.vue?vue&type=script&lang=js&"
export * from "./AiSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ba9bb8",
  null
  
)

export default component.exports